import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiwrapperService } from 'src/app/services/apiwrapper.service';
import { DataManipulationService } from 'src/app/services/data-manipulation.service';

@Component({
  selector: 'app-reporting-container',
  templateUrl: './reporting-container.component.html',
  styleUrls: ['./reporting-container.component.scss']
})
export class ReportingContainerComponent implements OnInit {

  gotCategories: boolean = false;
  gotOnboardingReporting: boolean = false;
  isReporting: boolean = false;
  isActionPlan: boolean = false;
  actionPlanCompleted: boolean = false;
  isNonMember: boolean = false;
  isCurrentNonEligibleCheckinRunning: boolean = false;
  
  reportingCategories: any[] = [];
  reportingCategoriesStatements: any[] = [];
  categoryActions: any[] = [];
  actionPlanActions: any[] = [];
  actionAssignees: any[] = [];
  usersForFilter: any[] = [];
  chartDataForApv: any[] = [];
  chartDataForOnboarding: any[] = [];
  scoreColorInterval: any[] = [];

  
  currentCustomPollUuid: any;
  currentCustomPoll: any;
  reportingDetails: any;
  reportingStatementsResponses: any;
  memberPrio: any;
  selectedUserTeam: any;
  selectedUserForOnboarding: any = null;
  selectedDateRangeForOnboarding: any = null;
  userTeams: any;
  userTeamsForOnboarding: any;

  constructor(public data: DataManipulationService, public api: ApiwrapperService, public router: Router,
              private activeRoute: ActivatedRoute, private translate: TranslateService) { }

  ngOnInit(): void {
    this.currentCustomPollUuid = this.activeRoute.snapshot.paramMap.get('pollUuid');
    this.getWorkspaceIntervals();
    this.getSelectedCustomPoll();
  }

  getWorkspaceIntervals() {
    //@ts-ignore
    const workspaceIntervals = JSON.parse(localStorage.getItem('WORKSPACE')).indicatorIntervals;
    this.scoreColorInterval = workspaceIntervals.map((interval: any) => ({
      min: interval.min,
      max: interval.max,
      //@ts-ignore
      color: interval.indicatorColor.color
    }));
  }

  getSelectedCustomPoll() {
    if (this.data.selectedCustomPoll) {
      this.data.showLoading();
      this.currentCustomPoll = {
        ...this.data.selectedCustomPoll,
        isLocked: this.data.selectedCustomPoll.status === this.translate.instant('custom_poll_temp_loop_locked'),
        reportIsReady: this.data.selectedCustomPoll.reportPath !== null
      };
      this.getCategoriesAndStatements();
    } else {
      this.data.showLoading();
      this.api.getWorkspaceCustomPoll().subscribe((res: any) => {
        this.currentCustomPoll = res._embedded["custom-polls"].filter((x: { uuid: any; }) => x.uuid === this.currentCustomPollUuid).map((poll: any) => {
          return {
            ...poll,
            isLocked: poll.status === this.translate.instant('custom_poll_temp_loop_locked'),
            reportIsReady: poll.reportPath !== null
          }
        })[0];
        this.getReportingDetails();
      })
    }
  }

  private getReportingRequest() {
    return this.currentCustomPoll.customPollTemplate.type === 'onboarding' ?
      this.api.getOnboardingCustomPollResponseRate(this.currentCustomPollUuid) :
      this.api.getCustomPollResponseRate(this.currentCustomPollUuid);
  }

  getReportingDetails() {
    this.getReportingRequest().subscribe((res: any) => {
      this.currentCustomPoll.reportingDetails = res;
      this.getCategoriesAndStatements();
    });
  }

  getCategoriesAndStatements() {
    if (this.currentCustomPoll.customPollTemplate.type === 'apv') {
      this.api.getReportingCategories(this.currentCustomPollUuid).subscribe((res: any) => {
        this.reportingCategories = res._embedded["custom-poll-categories-responses"];
        this.reportingDetails = {
          logo: '',
          type: this.currentCustomPoll.customPollTemplate.type, 
          startDate: this.currentCustomPoll.startDate.date, 
          endDate: this.currentCustomPoll.endDate.date,
          //@ts-ignore
          workspaceName: JSON.parse(localStorage.getItem('WORKSPACE')).name,
          reportingDetails: this.currentCustomPoll.reportingDetails,
        };
        this.getTeamsForSelector();
        this.setAssigneesForTasks();
        this.getCategoryScore();
      });
    } else {
      this.getTeamsForOnboardingSelector();
      this.reportingDetails = {
        logo: '',
        type: this.currentCustomPoll.customPollTemplate.type, 
        startDate: this.currentCustomPoll.startDate.date, 
        endDate: this.currentCustomPoll.endDate.date,
        //@ts-ignore
        workspaceName: JSON.parse(localStorage.getItem('WORKSPACE')).name,
        reportingDetails: this.currentCustomPoll.reportingDetails
      };
    }
  }
  
  getCheckinsForReporting() {
    const teamUuidForXTeam = this.selectedUserTeam !== null && this.selectedUserTeam !== undefined ? this.selectedUserTeam.uuid : null;
    this.reportingCategories = [];
    this.api.getReportingCheckins(this.currentCustomPollUuid, teamUuidForXTeam, this.selectedUserForOnboarding, this.selectedDateRangeForOnboarding, this.isNonMember)
    .pipe(
      map(res => res?._embedded?.collections ?? []),
      map(collections => {
        if (this.currentCustomPoll.customPollTemplate.type === 'onboarding') {
          return collections;
        }
        return collections.map((item: any) => {
          const {score, ...rest} = item;
          return {
            ...rest,
            checkinStarted: this.isCheckinStarted(item.startDate.date),
            collection: {
              ...item.collection,
              collectionScore: score
            }
          }
        });
      })
    )
    .subscribe((res:any) => {
      this.reportingCategories = res;
      if (this.currentCustomPoll.customPollTemplate.type === 'onboarding') {
        this.getCheckinsScore();
      } else {
        this.reportingCategories.reverse();
        this.checkCurrentCheckin();
        this.gotOnboardingReporting = true;
        this.isReporting = true;
        this.data.hideLoading();
      }
    });
  }

  checkCurrentCheckin() {
    this.isCurrentNonEligibleCheckinRunning = this.reportingCategories.some((checkin: any) => checkin.checkinStarted && !checkin.eligibleForResult);
  }

  isCheckinStarted(startDate: any): boolean {
    const newStartDate = new Date(startDate);
    const today = new Date();
    today.setHours(0,0,0,0);
    newStartDate.setHours(0,0,0,0);
    return newStartDate <= today;
  }

  setAssigneesForTasks() {
    this.api.getCustomPollTaskAssignees(this.currentCustomPollUuid).subscribe((res: any) => {
      this.actionAssignees = res.users;
    });
  }

  getCategoryScore() {
    this.chartDataForApv = [];
    const categoryCalls = this.reportingCategories.map((category: any, index: number) => {
      return this.api.getCategoryScore(
        this.currentCustomPollUuid,
        category.category.uuid,
        this.selectedUserTeam !== null && this.selectedUserTeam !== undefined ? [this.selectedUserTeam.uuid] : []
      ).pipe(
        map((res: any) => {
          const categoryScore = res.categoryScore;
          category.category.categoryScore = categoryScore;
          if (category.questions !== 0) {
            this.scoreColorInterval.forEach((scoreInterval: any) => {
              if (categoryScore >= scoreInterval.min && categoryScore <= scoreInterval.max) {
                category.color = scoreInterval.color;
                this.chartDataForApv[index] = {
                  datasets: [{
                    data: [categoryScore,(100 - categoryScore)],
                    backgroundColor: [
                      //@ts-ignore
                      this.data.colors[''+category.color], "#E6E6E6"
                    ],
                  }]
                };
              }
            });
          } else {
            this.chartDataForApv[index] = {
              datasets: [{
                data: [100,0],
                backgroundColor: [
                  "#E6E6E6"
                ],
              }]
            };
          }
          return category;
        })
      );
    });
    forkJoin(categoryCalls).subscribe((res: any) => {
      this.getCategoryActions('', true);
      this.gotCategories = true;
      this.isReporting = true;
      this.data.hideLoading();
    });
  }

  getCheckinsScore() {
    let checkinScore = 0;
    const teamUuidForXTeam = this.selectedUserTeam !== null && this.selectedUserTeam !== undefined ? this.selectedUserTeam.uuid : null;

    const checkinCalls = this.reportingCategories.map((checkin: any) => {
      return this.api.getReportingCheckinsScore(
        this.currentCustomPollUuid,
        checkin.uuid,
        teamUuidForXTeam,
        this.selectedUserForOnboarding,
        this.selectedDateRangeForOnboarding,
        this.isNonMember
      ).pipe(
        map((res: any) => {
          checkin.collection.collectionScore = res.collectionScore;
          checkinScore = checkin.collection.collectionScore;
          if ((this.reportingDetails.type === 'onboarding' && checkin.users !== 0 && checkinScore) || (this.reportingDetails.type === 'dysfunctional' && checkin.checkinStarted && checkin.eligibleForResult)) {
            this.scoreColorInterval.forEach((scoreInterval: any) => {
              if (checkinScore >= scoreInterval.min && checkinScore <= scoreInterval.max) {
                checkin.color = scoreInterval.color;
                this.chartDataForOnboarding.push({
                  datasets: [{
                    data: [checkinScore,(100 - checkinScore)],
                    backgroundColor: [
                      //@ts-ignore
                      this.data.colors[''+checkin.color], "#E6E6E6"
                    ],
                  }]
                });
              }
            });
          } else {
            checkin.color = 'blue';
            this.chartDataForOnboarding.push({
              datasets: [{
                data: [100,0],
                backgroundColor: [
                  "#E6E6E6"
                ],
              }]
            });
          }
          return checkin;
        })
      );
    });
    forkJoin(checkinCalls).subscribe((res: any) => {
      this.gotOnboardingReporting = true;
      this.isReporting = true;
      this.data.hideLoading();
    });
  }

  getCategoryStatements(category: any) {
    this.api.getReportingCategoryStatements(this.currentCustomPollUuid, category.categoryUuid, category.teamUuid).subscribe((res: any) => {
      this.getStatementsScore(res._embedded["custom-poll-category-questions"], category.teamUuid, null);
      this.getCategoryActions(category.categoryUuid, false);
    });
  }

  getCheckinStatements(checkin: any) {
    const isDysfunctional = this.currentCustomPoll.customPollTemplate.type === 'dysfunctional';
    const teamUuidForXTeam = this.selectedUserTeam !== null && this.selectedUserTeam !== undefined ? this.selectedUserTeam.uuid : [];
    this.api.getCustomPollTimedQuestionsStatements(checkin.collection.uuid, false).subscribe((res: any) => {
      this.getStatementsScore(res._embedded["timed-collection-questions"], teamUuidForXTeam, checkin);
    });
  }

  getCategoryActions(categUuid: string, fromActionPlan: boolean) {
    const teamUuidForXTeam = this.selectedUserTeam !== null && this.selectedUserTeam !== undefined ? this.selectedUserTeam.uuid : this.userTeams?.teams[1]?.uuid;
    this.api.getCustomPollTasks(this.currentCustomPollUuid, categUuid, teamUuidForXTeam).subscribe((res:any) => {
      if (categUuid !== '' && !fromActionPlan) {
        this.categoryActions = res._embedded["custom-poll-tasks"];
      } else {
        this.actionPlanActions = res._embedded["custom-poll-tasks"];
      }
    });
  }

  getTeamsForSelector() {
    this.api.getCustomPollTeamsForSelector(this.currentCustomPollUuid).subscribe((res:any) => {
      this.userTeams = this.setUserTeams(res.teams);
      this.getActionPlanStatus();
    });
  }

  getTeamsForOnboardingSelector() {
    this.api.getCustomPollOnboardingTeamsForSelector(this.currentCustomPollUuid).subscribe((res:any) => {
      this.userTeamsForOnboarding = this.setUserTeams(res._embedded["my-available-teams"]);
      if (this.userTeamsForOnboarding.teams.length === 1) {
        this.teamChanged({changedTeamUuid: this.userTeamsForOnboarding.selectedTeam.uuid, isNonMembers: false});
      } else {
        this.getCheckinsForReporting();
      }
    });
  }

  getAvailableUsersForOnboarding() {
    const teamUuidForXTeam = this.selectedUserTeam !== null && this.selectedUserTeam !== undefined ? this.selectedUserTeam.uuid : null;
    this.api.getCustomPollAvailableUsers(this.currentCustomPollUuid, teamUuidForXTeam, this.isNonMember).subscribe((res: any) => {
      this.usersForFilter = res._embedded["my-available-users"];
    });
  }

  createCategoryAction(actionDetails: any) {
    const teamUuidForXTeam = this.selectedUserTeam !== null && this.selectedUserTeam !== undefined ? this.selectedUserTeam.uuid : this.userTeams.teams[1].uuid;
    actionDetails.customPollUuid = this.currentCustomPollUuid;
    if (this.selectedUserTeam !== null && this.selectedUserTeam !== undefined) {
      actionDetails.teamUuid = this.selectedUserTeam;
    }
    this.api.postCustomPollTask(actionDetails, teamUuidForXTeam).subscribe((res:any) => {
      this.categoryActions.unshift(res);
      this.actionPlanActions.unshift(res);
    });
  }

  getStatementsScore(categoryQuestions: any, teamsUuid: any, checkin: any) {
    const isOnboarding = this.currentCustomPoll.customPollTemplate.type === 'onboarding';
    const isDysfunctional = this.currentCustomPoll.customPollTemplate.type === 'dysfunctional';
    const scoreCalls = categoryQuestions.map((statement: any) => {
      const categoryStatement = (isOnboarding || isDysfunctional) ? statement.question : statement;
      if (categoryStatement.type === 'open') {
        return of(statement);
      }
      return this.api.getQuestionScore(
        ((isDysfunctional || isOnboarding) && checkin) ? checkin.uuid : this.currentCustomPollUuid,
        categoryStatement.uuid,
        teamsUuid,
        this.selectedUserForOnboarding,
        this.selectedDateRangeForOnboarding,
        this.isNonMember,
        isOnboarding,
        isDysfunctional
      ).pipe(
        map((res: any) => {
          categoryStatement.eligibleForScore = res.eligibleForScore;
          categoryStatement.score = res.questionScore;
          categoryStatement.rating = Math.round(res.questionScore / 10);
          return statement;
        })
      );
    });
    forkJoin(scoreCalls).subscribe((updatedStatements: any) => {
      this.reportingCategoriesStatements = updatedStatements;
    })
  }

  getStatementResponses(statement: any) {
    const isDysfunctional = this.currentCustomPoll.customPollTemplate.type === 'dysfunctional';
    const isOnboarding = this.currentCustomPoll.customPollTemplate.type === 'onboarding';

    if (statement.statementType === 'scaled') {
      this.api.getReportingScaledStatementResponses(this.currentCustomPollUuid, statement.statementUuid, statement.checkinUuid, statement.teamUuid, this.selectedUserForOnboarding, this.selectedDateRangeForOnboarding, this.isNonMember, isDysfunctional, isOnboarding).subscribe((res:any) => {
        this.reportingStatementsResponses = {type: statement.statementType, responses: res};
      });
    }
    if (statement.statementType === 'open') {
      this.api.getReportingOpenStatementResponses(this.currentCustomPollUuid, statement.statementUuid, statement.checkinUuid, statement.teamUuid, statement.page, statement.limit, this.selectedUserForOnboarding, this.selectedDateRangeForOnboarding, this.isNonMember, isDysfunctional, isOnboarding).subscribe((res:any) => {
        this.reportingStatementsResponses = {type: statement.statementType, responses: res};
      });
    }
  }

  setUserTeams(teamsToFilter: any) {
    this.memberPrio = {...this.data.userRole};
    let userTeams = [];
    if (this.currentCustomPoll.customPollTemplate.type === 'apv') {
      userTeams.push({name: this.translate.instant('custom_poll_main_reporting_all_teams'), uuid: '', nonMembers: false});
    }
    if (this.memberPrio.role.workspacePriority >= 20) {
      this.selectedUserTeam = null;
      teamsToFilter.forEach((team:any) => {
        userTeams.push({name:team.name, uuid:team.uuid});
      });
      if (this.currentCustomPoll.customPollTemplate.type === 'onboarding') {
        userTeams.push({name: this.translate.instant('custom_poll_main_reporting_people_outside_team'), uuid: '', nonMembers: true});
      }
    }
    if (this.memberPrio.role.workspacePriority < 20) {
      teamsToFilter.forEach((team: any, index:number) => {
        if (index === 0) {
          this.selectedUserTeam = {name: team.name, uuid: team.uuid, nonMembers: false};
        }
        userTeams.push({name: team.name, uuid: team.uuid, nonMembers: false});
      });
    }
    return {teams: userTeams, selectedTeam: this.selectedUserTeam};
  }

  teamChanged(event: any) {
    this.data.showLoading();
    this.selectedUserForOnboarding = null;
    this.isNonMember = event.isNonMembers;
    this.selectedUserTeam = event.changedTeamUuid !== '' ? {uuid: event.changedTeamUuid}:null;
    if (this.currentCustomPoll.customPollTemplate.type === 'apv') {
      this.getCategoryScore();
    } else {
      this.getAvailableUsersForOnboarding();
      this.getCheckinsForReporting();
    }
  }

  userChanged(event: any) {
    this.data.showLoading();
    this.selectedUserForOnboarding = event;
    this.getCheckinsForReporting();
  }

  dateRangeChanged(event: any) {
    this.data.showLoading();
    this.selectedDateRangeForOnboarding = event;
    this.getCheckinsForReporting();
  }

  changePages(isReporting: boolean, isActionPlan: boolean) {
    if (isReporting && !isActionPlan) {
      this.isReporting = true;
      this.isActionPlan = false;
    } else {
      this.isReporting = false;
      this.isActionPlan = true;
    }
  }

  filterActionPlanActionsByCategory(categoryUuid: string) {
    this.getCategoryActions(categoryUuid, true);
  }

  getActionPlanStatus() {
    const teamUuidForXTeam = (this.selectedUserTeam !== null && this.selectedUserTeam !== undefined) ? this.selectedUserTeam.uuid : this.userTeams.teams[1]?.uuid;
    this.api.getActionPlanStatus(this.currentCustomPollUuid, teamUuidForXTeam).subscribe((res: any) => {
      this.actionPlanCompleted = res.info ? false : true;
    });
  }

  setACtionPlanDone(event: any) {
    const teamUuidForXTeam = (this.selectedUserTeam !== null && this.selectedUserTeam !== undefined) ? this.selectedUserTeam.uuid : this.userTeams.teams[1]?.uuid;
    this.api.setActionPlanDone(this.currentCustomPollUuid, teamUuidForXTeam).subscribe((res: any) => {
      this.actionPlanCompleted = res.info ? false : true;
    });
  }

  lockCustomPoll() {
    this.openLockConfirmationModal();
    this.api.lockCustomPoll(this.currentCustomPollUuid).subscribe((res: any) => {
      this.currentCustomPoll = {
        ...this.currentCustomPoll,
        ...res
      };
      this.currentCustomPoll.isLocked = this.currentCustomPoll.status === this.translate.instant('custom_poll_temp_loop_locked');
      this.currentCustomPoll.reportIsReady = this.currentCustomPoll.reportPath !== null;
    });
  }

  downloadCustomPollReport(path: string) {
    const fullUrl = this.data.baseUrl + path;
    const extension = path.split('.').pop() || '';
    const lang = this.translate.currentLang || 'en';
    const localeMap: any = {en: 'en', da: 'da'};
    const locale = localeMap[lang] || 'en';
    const monthName = new Intl.DateTimeFormat(locale, {month: 'long'}).format(new Date(this.currentCustomPoll.reportDate.date)).toLowerCase();
    const finalName = `${this.currentCustomPoll.workspace.name}_${this.currentCustomPoll.name}_${monthName}.${extension}`; 
    const a = document.createElement('a');
    a.href = fullUrl;
    a.download = finalName;
    a.click();
    a.remove();
  }

  openLockConfirmationModal() {
    // @ts-ignore
    document.getElementById('lockConfirmation').click();
  }

  closeLockConfirmationModal() {
    document.getElementById('closeLockConfirmationModal')?.click();
  }

  resetOnboardingFilters() {
    this.isNonMember = false;
    this.selectedUserForOnboarding = null;
    this.selectedDateRangeForOnboarding = null;
    this.selectedUserTeam = null;
    this.reportingCategories = [];
    this.getCheckinsForReporting();
  }

}
